import { commonTypes } from '../common';

export const types = {
  SET_CA_NEEDS: 'UINEEDS/SET_CA_NEEDS',
};

export const initialState = {
  updateCANeeds: {
    clientAccounts: null,
    requiredAccount: false,
    accountInfo: null,
  },
};

const UINeedsAccountReducer = (state, action) => {
  switch (action.type) {
    case types.SET_CA_NEEDS: {
      const { requiredAccount, customerAccounts } = action.payload;

      const newState = { ...state };
      newState.updateCANeeds = {
        ...state.updateCANeeds,
        requiredAccount,
        clientAccounts: customerAccounts,
      };
      return {
        state: newState,
        stepsMustBeEvaluated: true,
      };
    }
    case commonTypes.SET_ACCOUNT_INFO: {
      const { customerAccountId, customerAccountNumber } = action.payload;

      const newState = { ...state };

      if (customerAccountId) {
        newState.updateCANeeds.accountInfo = customerAccountId;
      }
      if (customerAccountNumber) {
        newState.updateCANeeds.accountInfo = customerAccountNumber;
      }

      return {
        state: newState,
        stepsMustBeEvaluated: false,
      };
    }
    default:
      return null;
  }
};

export const actions = {
  setCANeeds: info => ({
    type: types.SET_CA_NEEDS,
    payload: {
      ...info,
    },
  }),
};

export default UINeedsAccountReducer;
